export default {
  filter_permission_keys: {
    loading_contact_name: "loading_contact_name",
    loading_contact_phone: "loading_contact_phone",
    loading_contact_email: "loading_contact_email",
    delivery_contact_name: "delivery_contact_name",
    delivery_contact_phone: "delivery_contact_phone",
    delivery_contact_email: "delivery_contact_email",
  },
  hideHeader: [
    "/resetPassword",
    "/dashboard",
    "/account",
    "/team",
    "/carriers",
    "/clients",
    "/users",
    "/pricing",
    "/settings",
    "/quotes",
    "/orders",
    "/archives",
    "/tracking",
    "/invoices",
    "/claims",
    "/carrier_quotes",
    "/carrier_home",
    "/availabilities",
  ],

  show_header_footer_paths: [
    "",
    "/",
    "/user_login",
    "/login",
    "/staffLogin",
    "/carriersignup",
    "/usersignup",
    "/solutions",
    "/solutions/carrier",
    "/contact",
    "/demo",
    "/join",
    "/web_tracking",
    "/forget_password",
    "/admin_forgotPassword",
    "/staff_forgotPassword",
    "/terms",
    "/privacy",
  ],
};
